import { EventBusForThirdParty } from '../event-bus'
import { HotelloversLikeEventSubscriptionFacade } from './hotellovers-like'
import {
  handleProductDetailViewEventForHotelloversAppBFF,
} from './hotellovers/handle-product-detail-view-for-hotellovers-app-bff'

export class HotelloversEventSubscriptionFacade extends HotelloversLikeEventSubscriptionFacade {
  protected subscribeHostSpecific(eventBus: EventBusForThirdParty): void {
    eventBus.subscribe('product-detail-view', handleProductDetailViewEventForHotelloversAppBFF)
  }
}
